/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { HeaderWidgetComponent } from './header-widget.component';

@Component({
  template: `
    <div
      class="gridheader {{ header?.key }}"
      (click)="onContainerClick($event)"
      (mouseenter)="togglePopOver(true)"
      (mouseleave)="togglePopOver(false)"
    >
      <i
        *ngIf="enableSearch"
        class="fa fa-filter {{ searchParamModel ? 'with-filter' : '' }}"
        style="cursor: pointer;"
        (click)="togglePopOver(true)"
      ></i>
      <span class="label" [innerHTML]="header?.label"></span>
      <div
        *ngIf="enableSearch"
        class="popover search-app"
        [ngClass]="{ 'd-none': !showPopOver, right: isLast }"
      >
        <div class="input-group">
          <span
            class="input-group-addon"
            id="basic-addon1"
            (click)="searchClick()"
          >
            <i class="fa fa-search"></i>
          </span>
          <input
            #searchInput
            type="text"
            class="form-control"
            (keydown.escape)="clearClick(true)"
            (keydown.enter)="searchClick()"
            [(ngModel)]="searchParamModel"
            (ngModelChange)="onSearchChange()"
            placeholder="Search for a seller"
            aria-describedby="basic-addon1"
          />
          <ng-container
            *ngIf="searchParamModel && searchParamModel?.length > 0"
          >
            <a
              class="btn btn-link clear-app-search p-0 m-2"
              (click)="clearClick(false)"
              ><i class="fa fa-times"></i
            ></a>
          </ng-container>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./grid-header.component.scss']
})
export class GridHeaderWithPopoverSearchComponent extends HeaderWidgetComponent {
  @ViewChild('searchInput') searchInput: ElementRef;

  showPopOver = false;
  searchParamModel: string;

  @Input() enableSearch: boolean;
  @Output() searchEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private elementRef: ElementRef) {
    super();
  }

  focusInput() {
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.focus();
    }
  }

  togglePopOver(show: boolean) {
    this.showPopOver = show;

    if (this.showPopOver) {
      // Use setTimeout to ensure the popover is visible before focusing
      setTimeout(() => this.focusInput(), 0);
    }
  }

  onSearchChange() {
    this.searchEvent.emit(this.searchParamModel);
  }

  searchClick() {
    this.togglePopOver(false);
    this.searchEvent.emit(this.searchParamModel);
  }

  clearClick(close: boolean) {
    this.searchParamModel = '';
    if (close) this.togglePopOver(false);
    this.searchEvent.emit(this.searchParamModel);
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside && this.showPopOver) {
      this.togglePopOver(false);
    }
  }

  onContainerClick(event: MouseEvent) {
    event.stopPropagation();
  }
}
